import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { websiteThemeV0Schema } from './v0';
import { websiteThemeLegacySchema } from '../legacy/entity';
import { migrateWebsiteThemeLegacyToV0 } from '../legacy/migration';

export const WebsiteThemeEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: websiteThemeV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: websiteThemeLegacySchema, up: migrateWebsiteThemeLegacyToV0 }],
});

export type WebsiteTheme = InferredEntity<typeof WebsiteThemeEntitySchema>;
